import api from 'api/axiosInstance';
import { getToken, createApiUrl } from '../../util';

type ChangeSetbackPayload = {
	uuid: string;
	setbacks: Record<string, number>;
	resetLayout?: boolean;
};

async function changeSetback(payload: ChangeSetbackPayload) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};
	await api.post(createApiUrl('/designs/change-setback'), payload, config);
}

export { changeSetback };
